module.exports = {
  formatCardType(type = '') {
    return {
      ID_CARD: '身份证', 
      PASS_PORT: '护照', 
      HONGKONG_PASS: '港澳居民来往内地通行证', 
      TAIWAN_PASS: '台湾居民来往大陆通行证', 
      HMT_RESIDENCE_PERMIT: '港澳台居民居住证', 
      FOREIGNERS_PERMANENT_RESIDENCE_PERMIT: '外国人永久居留身份证', 
    }[type] || '其他';
  },
  // 获取连接的参数对象params
  getUrlSearchParams() {
    return Object.fromEntries(new URLSearchParams(window.location.search).entries());
  },
  getUrlParams(url) {
    if (!url) return {};
    const urlArr = url.split('?') || [];
    return urlArr[1] ? Object.fromEntries(new URLSearchParams(urlArr[1]).entries()) : {};
  },
};



// WEBPACK FOOTER //
// ./src/mods/tools.js